import React from 'react';
import { Outlet, useParams, useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { BuilderProvider } from '../../contexts/BuilderContext';
export function Layout() {
  const {
    builderId
  } = useParams<{
    builderId: string;
  }>();
  const location = useLocation();
  // Check if we're in admin mode
  const isAdmin = location.pathname.startsWith('/admin');
  return <BuilderProvider builderId={isAdmin ? null : builderId || null} data-id="element-54">
      <div className="flex h-screen w-full bg-slate-50 overflow-hidden" data-id="element-55">
        <Sidebar data-id="element-56" />
        <main className="flex-1 overflow-y-auto" data-id="element-57">
          <div className="min-h-full p-8" data-id="element-58">
            <Outlet data-id="element-59" />
          </div>
        </main>
      </div>
    </BuilderProvider>;
}